import { defineStore } from 'pinia';
import { ReportRecordData } from '@/services/api/resources/analytics-builder/model';

export type DetailedViewType = 'submitted-forms' | 'schedule-forms' | 'actions' | 'form-items' | 'negative-responses';
export type DetailedViewOptions = { head? : string | number };

interface State {
  reportId: number | undefined;
  report: ReportRecordData | null;
  resourceId: number| string | undefined;
  widgetKey: string;
  detailedViewType: DetailedViewType;
  options: DetailedViewOptions;
}

export const useDetailedViewStore = defineStore('detailedView', {
  state: (): State => ({
    reportId: undefined,
    report: null,
    resourceId: undefined,
    widgetKey: '',
    detailedViewType: 'submitted-forms',
    options: {},
  }),
  actions: {
    setDetailedView(detailedView: State) {
      this.reportId = detailedView.reportId;
      this.report = detailedView.report;
      this.resourceId = detailedView.resourceId;
      this.widgetKey = detailedView.widgetKey;
      this.detailedViewType = detailedView.detailedViewType;
      this.options = detailedView.options;
    },
  },
  getters: {
    isValid: (state: State) => state.report && state.widgetKey !== '',
  },
});
